const requireTemplates = import.meta.glob('~~/**/components/modules/templates/**/Template.vue');
const templates = Object.entries(requireTemplates).filter(activeLayers).map(([key, value]) => ({
    key: key.replace('/Template.vue', '').split('/').last(),
    value
}));

const requireSetups = import.meta.glob('~~/**/components/modules/templates/**/Setup.vue');
const setups = Object.entries(requireSetups).filter(activeLayers).map(([key, value]) => ({
    key: key.replace('/Setup.vue', '').split('/').last(),
    value
}));

export {
    templates,
    setups
};
